export enum DocuSignFiltersActionType {
  SetSearchInputValue = 'docuSignFilters/setSearchInputValue',
  ChangeFilters = 'docuSignFilters/changeFilters',
  ResetAllFilters = 'docuSignFilters/resetAllFilters',
  ToggleFiltersPopup = 'docuSignFilters/toggleFiltersPopup',
  FilterTemplatesByMembers = 'docuSignFilters/filterTemplatesByMembers',
}
